module.exports = __webpack_public_path__ + "img/noKeywords.fbcf6db1.png";